module.exports = __webpack_public_path__ + "static/media/toolbar-show-hide-area.0fba2416.svg";